<template>
	<div>
		<div class="common-seach-wrap">
			<el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">

				<el-form-item label="状态">
					<el-select size="small" v-model="searchForm.status" placeholder="请选择">
						<el-option label="全部" value=""></el-option>
						<el-option label="未审核" value="0"></el-option>
						<el-option label="已通过" value="1"></el-option>
						<el-option label="已拒绝" value="2"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table size="small" :data="tableData" border style="width: 100%">
			<el-table-column type="index" width="150" align="center" label=""></el-table-column>
			<el-table-column prop="user.nickName" width="150" align="center" label="姓名">
			</el-table-column>
			<el-table-column prop="user.mobile" width="150" align="center" label="手机号">
			</el-table-column>
			<!-- <el-table-column type="income_id" label="ID"></el-table-column> -->

			<el-table-column prop="amount" width="150" align="center" label="提现金额">
				<template slot-scope="scope">
					<span style="color:red">￥{{ scope.row.amount }}元</span>
				</template>
			</el-table-column>
			<el-table-column prop="status_text.message" width="150" align="center" label="审核状态">
			</el-table-column>
			<el-table-column prop="status_text.reason" width="150" align="center" label="审核意见">
			</el-table-column>
			<el-table-column prop="card.number" align="center" label="银行卡号/支付宝账号">
			</el-table-column>
			<el-table-column prop="card.name" align="center" label="开户行名/支付宝名">
			</el-table-column>
			<el-table-column prop="card.address" align="center" label="开户地址">
			</el-table-column>
			<el-table-column label="操作" width="150" align="center">
				<template slot-scope="scope">
					<el-button v-if="scope.row.status == 1" @click="editClick(scope.row)" type="primary" size="small">审核</el-button>
					<el-button v-else type="primary" disabled>已审核</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--分页-->
		<div class="pagination">
			<el-pagination @current-change="handleCurrentChange" background :current-page="curPage"
				:page-size="pageSize" layout="total, prev, pager, next" :total="totalDataNumber"></el-pagination>
		</div>
		<!--添加-->
		<Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')">
		</Edit>
	</div>
</template>

<script>
	import CashApi from "@/api/cash.js";
	import Edit from "./edit.vue";
	import {
		deepClone
	} from "@/utils/base.js";
	export default {
		components: {
			Edit
		},
		data() {
			return {
				/*当前编辑的对象*/
				categoryModel: {
					catList: [],
					model: {}
				},
				/*是否打开添加弹窗*/
				open_add: false,
				/*是否打开编辑弹窗*/
				open_edit: false,
				/*一页多少条*/
				pageSize: 20,
				/*一共多少条数据*/
				totalDataNumber: 4,
				/*当前是第几页*/
				curPage: 1,
				/*横向表单数据模型*/
				searchForm: {
					status: ""
				},
				tableData: [],
				/*当前编辑的对象*/
				userModel: {}
			};
		},
		created() {
			this.getData();
		},
		methods: {
			onSubmit() {
				this.curPage = 1;
				this.getData();
			},
			/*获取列表*/
			getData() {
				let self = this;
				let Params = self.searchForm;
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				self.loading = true;
				CashApi.PromotionCashlist(Params, true)
					.then(data => {
						self.loading = false;
						self.tableData = data.data.data;
						self.totalDataNumber = data.data.total;
					})
					.catch(error => {
						self.loading = false;
					});
			},

			/*选择第几页*/
			handleCurrentChange(val) {},
			/*关闭弹窗*/
			closeDialogFunc(e, f) {
				console.log(e, f);
				if (f == "add") {
					this.open_add = e.openDialog;
					if (e.type == "success") {
						this.getData();
					}
				}
				if (f == "edit") {
					this.open_edit = e.openDialog;
					if (e.type == "success") {
						this.getData();
					}
				}
			},
			/*打开编辑*/
			editClick(item) {
				this.userModel = deepClone(item);
				this.open_edit = true;
			},

			handleClick(row) {
				console.log(row);
			},
			/*打开添加*/
			addClick() {
				this.open_add = true;
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/views/cash/cashmoney/usercash/cash.vue